<template>
  <div class="blog-search">
    <SearchRefiners
      :results="results"
      :selectedFacetOptions="selectedFacetOptions"
      @applyFilters="onApplyFilters"
      @resetFilters="onResetFilters"
    />
    <div>
      <div class="blog" v-if="results.rows.length > 0">
        <div v-for="blog in results.rows" class="blog-entry" :key="blog.id" itemscope
          itemtype="https://schema.org/NewsArticle">
          <div class="blog-date" itemprop="datePublished">{{ blog.publicationDate }}</div>
          <meta itemprop="url" :content="blog.url" />
          <div class="blog-details">
            <div>
              <div class="blog-title" style="word-wrap: break-word;" itemprop="name" @click="onItemClicked(blog)">
                {{ blog.title }}</div>
              <div class="blog-date" @click="onItemClicked(blog)">{{ blog.publicationDate }}</div>
              <div class="blog-description" style="word-wrap: break-word;"><span v-html="blog.description"
                  itemprop="description" @click="onItemClicked(blog)"></span>&nbsp;
                <a class="blue-arrow" style="display: inline;" :title="blog.title" :href="blog.url">{{ labels.more }}</a>
              </div>
            </div>
          </div>
        </div>
        <Pager :total-items="results.totalRows" :current-items="results.rows.length" @click="onShowMore"></Pager>
      </div>
      <div class="no-items" v-if="results.rows.length == 0 && !isLoading">{{ labels.noItemsFound }}</div>
    </div>
    <div class="please-wait" v-if="isLoading">
      <img src="../assets/pic_loading.gif" />
    </div>
  </div>
</template>

<script>
import { Bus } from './services/bus.js'
import { Labels } from './services/labels.js'
import { Settings } from './services/settings.js'
import { Utils } from './services/utils.js'
import Facet from './ui/Facet.vue'
import FacetOption from './ui/FacetOption.vue'
import Pager from './ui/Pager.vue'
import axios from 'axios'
import { SessionState } from './services/session-state.js'
import SearchRefiners from './ui/SearchRefiners.vue'

export default {
  name: 'blogSearch',
  components: {
    Facet,
    FacetOption,
    Pager,
    SearchRefiners
  },
  props: {
    resultCount: String,
  },
  data() {
    return {
      labels: Labels,
      isLoading: false,
      currentQuery: "",
      results: {
        rows: [],
        facets: []
      },
      tags: "",
      collapsedFacets: Settings.blog.collapsedFacets,
      selectedFacetOptions: [],
      isFirstQuery: true,
      hiddenFacets: Settings.hiddenFacets
    }
  },
  created() {
    Bus.$on("start-search", this.search)
  },
  beforeDestroy() {
    Bus.$off('start-search');
  },
  mounted() {
    var facetOpts = SessionState.get("blog", "facets");
    if (facetOpts) {
      this.selectedFacetOptions = JSON.parse(facetOpts);
    }
  },
  methods: {
    onItemClicked(item) {
      if (!item) return;
      window.open(item.url, "_self");
    },
    isCollapsed(facet) {
      if (this.collapsedFacets.indexOf(facet.name) != -1) return true;
      else return false;
    },
    search(filters, fromWithin) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      oThis.tags = filters.tags;
      console.log("Searching for blog with " + filters.query)
      oThis.isLoading = true;
      if (!fromWithin && !this.isFirstQuery) {
        this.selectedFacetOptions = [];
        SessionState.set("blog", "facets", null);
      }
      this.isFirstQuery = false;
      var url = Utils.constructNewQueryUrl("blog", filters.query, oThis.selectedFacetOptions);
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, false);
        if (oThis.tags.length > 0) {
          oThis.selectTagsInFacets();
        }
        oThis.$emit("update:modelValue", oThis.results.totalRows);
        Utils.applyVisualUpdates(".blog-search");
        oThis.isLoading = false;
        if (!fromWithin) {//we only report to analytics search queries, not results refining
          Utils.reportResultsToAnalytics("News Search", filters.query, oThis.results.totalRows);
        }
      }).catch(function (err) {
        console.error("Error loading blog: " + err.message);
        oThis.results = { rows: [], facets: [] };
        oThis.$emit("update:modelValue", oThis.results.totalRows);
        oThis.isLoading = false;
      });

    },
    onShowMore() {
      var oThis = this;
      if (oThis.isLoading) return;
      console.log("Searching for more blog with " + this.currentQuery)
      oThis.isLoading = true;
      var url = Utils.constructQueryUrl("blog", this.currentQuery, oThis.results, oThis.selectedFacetOptions);
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, true);
        Utils.applyVisualUpdates(".blog-search");
      }).catch(function (err) {
        console.error("Error loading blog: " + err.message);
        oThis.results = { rows: [], facets: [] };
      }).finally(() => {
        oThis.isLoading = false;
      });
    },
    onFacetOptionChecked(opt) {
      if (!opt) return;
      this.selectedFacetOptions = Utils.processFacetChecked(this.selectedFacetOptions, opt);
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("blog", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    isFacetOptionChecked(val) {
      return (this.selectedFacetOptions.indexOf(val) != -1);
    },
    selectTagsInFacets() {
      if (!this.tags || this.tags.length == 0) return;
      if (this.results.facets.length == 0) return;
      var oThis = this;
      var bMustReload = false;
      var tags = oThis.tags.split(',');
      this.results.facets.forEach(function (facet) {
        facet.options.forEach(function (opt) {
          if (tags.indexOf(opt.id) != -1) {
            oThis.selectedFacetOptions.push(facet.id + "=" + opt.id);
            var pos = oThis.collapsedFacets.indexOf(facet.name);
            if (pos != -1) oThis.collapsedFacets.splice(pos, 1);  //we expand the category automatically
            bMustReload = true;
          }
        });
      });
      if (bMustReload) {
        this.search({ query: this.currentQuery, tags: "" }, true);
      }
    },
    onApplyFilters(facetId, selectedOptions) {
      var updatedOptions = this.selectedFacetOptions.filter(option => !option.startsWith(facetId))
      updatedOptions.push(...selectedOptions);
      this.selectedFacetOptions = updatedOptions
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("blog", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    onResetFilters(all, facetId) {
      if (all) {
        this.selectedFacetOptions = [];
      }
      else {
        this.selectedFacetOptions = this.selectedFacetOptions.filter(option => !option.startsWith(facetId));
      }
      this.search({ query: this.currentQuery, tags: "" }, true);
      SessionState.set("blog", "facets", null);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width: 100%;
  justify-content: center;
}

.blog-search>div {
  display: flex;
  flex-direction: row;
}

.blog-search .blog {
  width: 100%;
}

.blog .blog-entry {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px dotted #DDDDDD;
  padding-bottom: 10px;
}

.blog .blog-entry .blog-date {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: #777;
  text-transform: none;
}

.blog .blog-entry>.blog-date {
  width: 130px;
  min-width: 130px;
  padding-top: 3px;
}

.blog .blog-entry .blog-details {
  margin-left: 10px;
  color: #323232;
  cursor: pointer;
}

.blog .blog-entry .blog-details>div>.blog-date {
  display: none;
}

.blog .blog-entry .blog-details div.blog-title {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-weight: 700;
}

.blog .blog-entry .blog-details .blog-subtitle {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
}

.blog .blog-entry .blog-details .blog-description {
  font-family: "Gotham Narrow", Arial, Helvetica, sans-serif;
  font-size: 15px;
}

/*.blog .blog-entry .morelink { 
	display: inline-block;
	padding-top: 1px;
	padding-left: 10px;
	font-family: 'Gotham SSm A', 'Gotham SSm B', sans-serif;
	font-weight: 500;
	font-size: 12px;
	line-height: inherit;
	text-transform: uppercase;
	background-image: url('../assets/bullet-arrow-blue.png');
	background-repeat: no-repeat;
	background-size: 6px 9px;
    background-position: 0px 4px;
    color:#2655FF;
}*/

@media all and (min-width: 781px) and (max-width: 960px) {
  .blog .blog-entry>.blog-date {
    display: none;
  }

  .blog .blog-entry a.blog-details {
    margin-left: 0;
  }

  .blog .blog-entry .blog-details>div>.blog-date {
    display: block;
    margin-bottom: 10px;
  }
}

@media all and (max-width: 780px) {
  .blog-search>div {
    flex-wrap: wrap-reverse;
  }

  .blog-search .blog {
    width: 100%;
  }

  .blog .blog-entry>.blog-date {
    display: none;
  }

  .blog .blog-entry .blog-details>div>.blog-date {
    display: block;
    margin-bottom: 10px;
  }

  .blog .blog-entry .blog-details {
    margin-left: 0;
  }

}</style>
